//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Object,
      default: () => ({ type: 'free', price_from: null, price_to: null }),
    },
  },
  data() {
    // jw: we want to keep a local instance of the value in data so that we can modify it without
    //     forcing a 'input' to the parent. That will allow us to change the value without
    //     triggering the reloading of events.
    const { value } = this;
    return {
      localValue: { ...value },
      timeoutId: null,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.localValue = { ...value };
      },
      deep: true,
    },
  },
  methods: {
    select(value) {
      this.localValue.type = value;
      // jw: switching to free should trigger a search and scroll immediately. Switching to custom
      //     should set focus on the price_from field but wait for user input before fetching new
      //     results and scrolling.
      if (value === 'free') {
        this.emitInput();
      } else {
        // jw: this demands some explination. Since this select method is going to trigger a redraw
        //     that causes the input to appear, we need to give vue a chance to actually render it
        //     prior to setting focus. Otherwise focus will not take effect and nothing will
        //     actually happen.
        this.$nextTick(() => this.$refs.priceFrom.focus());
      }
    },
    change(key, value) {
      const n = value ? parseFloat(value) : null;
      this.localValue[key] = n;
      // jw: let's allow for a tenth of a second for the focus to shift between inputs before we
      //     emit the input and cause a fetch of new results with a scroll to the top of the page.
      this.timeoutId = window.setTimeout(this.emitInput, 100);
    },
    emitInput() {
      this.$emit('input', this.localValue);
    },
    clearTimeout() {
      if (this.timeoutId) {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    },
  },
};
